import { Byte } from '@angular/compiler/src/util';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';
import { Artikel } from '../../store/models/artikel';
import { ArtikelQuickView1Component } from '../artikel-quick-view1/artikel-quick-view1.component';

@Component({
    selector: 'kkis-app-artikel-list-widget1',
    templateUrl: './artikel-list-widget1.component.html',
    styleUrls: ['./artikel-list-widget1.component.scss']
})
export class ArtikelListWidget1Component implements OnInit {

    // Input
    @Input()
    artikel: Artikel.IArtikelDto;

    @Input()
    itemsPerRow: number;

    @Input()
    isList: boolean = false;

    // Images (from local <<NOT>> FROM DATABASE)
    imgPath: string = "assets/media/products/";
    imgFile: BlobPart[];
    // imgFile: string;

    imgMaxWidth: number;
    itemsPerRowMax: number;

    // Dialog
    dialogWidth: string;
    dialogHeight: string;

    // Utils
    isLoading: boolean = true;

    constructor(
        public dialog: MatDialog,
        private layoutUtilsService: LayoutUtilsService,
    ) { }

    ngOnInit(): void {

        var w = this.layoutUtilsService.getBootstrapClass();
        switch(w) {
            case 0:
            case 1: {
                this.dialogWidth = "95%";
                this.dialogHeight = "95%";
                this.itemsPerRowMax = 1;
                break;
            }
            case 2: {
                this.dialogWidth = "60%";
                this.dialogHeight = "80%";
                this.itemsPerRowMax = 2;
                break;
            }
            case 3: {
                this.dialogWidth = "60%";
                this.dialogHeight = "80%";
                this.itemsPerRowMax = 4;
                break;
            }
            default: {
                this.dialogWidth = "60%";
                this.dialogHeight = "80%";
                this.itemsPerRowMax = 6;
                break;
            }
        }

        // random image from local storage - FOR TEST PURPOSE ONLY
        // this.imgFile = this.imgPath + this.randomNumber(1, 22) + ".png";

        // const reader = new FileReader();
        // reader.onload = (e) => this.imgFile = e.target.result;
        // reader.readAsDataURL(new Blob(this.artikel.bild));

        this.imgFile = this.artikel.bild;

        this.isLoading = false;
    }

    onOpenArtikelQuickView() {
        const dialogRef = this.dialog.open(ArtikelQuickView1Component, {
            width: this.dialogWidth,
            data: {
                artikel: this.artikel,
                image: this.imgFile,
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log("dialog.closed => ", result);
        });
    }

    private randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
